import { SeasonEnum } from '@entities/Product';
import { RegionTypes } from '@app/Types/Region';
import {
  BannerAlloyDisks,
  BannerOils,
  BannerTyres,
  BannerTyresCordiant,
  BannerTyresKama,
  BannerTyresLandsail,
  BannerTyresSummer,
  BannerTyresViatti,
  BannerTyresWinter,
  BannerTyresWinterAction,
} from '@entities/BannerPage';
import { BannerType } from '@entities/BannerPage/module/types/bannerSchema';
import { Region } from '@enums/RegionList';

const BANNER_TYRES_REGION_IDS = [
  Region.Tver,
  Region.Kostroma,
  Region.Smolensk,
  Region.Bryansk,
  Region.Obninsk,
  Region.Lipetsk,
  Region.Penza,
  Region.Saransk,
  Region.Orel,
  Region.Elets,
];

const BANNER_ALLOY_DISKS_REGION_IDS = [
  Region.Novosibirsk,
  Region.Kazan,
  Region.NizhnyNovgorod,
  Region.Voronezh,
  Region.Perm,
  Region.Ufa,
  Region.SaintPetersburg,
  Region.Moscow,
  Region.Samara,
  Region.RostovOnDon,
];

export const generateBanners = ({
  urlPage,
  regionType,
  regionId,
  season,
}: {
  urlPage: string;
  regionType: RegionTypes;
  regionId: number;
  season: SeasonEnum;
}) => {
  const banners: BannerType[] = [];

  if ((season === SeasonEnum.Summer || urlPage === '/catalog/tyres/leto/') && regionType === RegionTypes.Branch) {
    banners.push(BannerTyresSummer);
  }

  if ((urlPage.includes('catalog/tyres/') || urlPage.includes('catalog/trucktyres/')) && BANNER_TYRES_REGION_IDS.includes(regionId)) {
    banners.push(BannerTyres);
  }

  if (urlPage.includes('/oils') && regionType === RegionTypes.Branch) {
    banners.push(BannerOils);
  }

  if (urlPage.includes('/catalog/tyres/kama/leto')) {
    banners.push(BannerTyresKama);
  }

  if (urlPage === '/catalog/tyres/cordiant/zima/' && regionType === RegionTypes.Branch) {
    banners.push(BannerTyresCordiant);
  }

  if (urlPage === '/catalog/tyres/viatti/zima/' && regionType === RegionTypes.Branch) {
    banners.push(BannerTyresViatti);
  }

  if (urlPage === '/catalog/tyres/landsail/') {
    banners.push(BannerTyresLandsail);
  }

  if (urlPage.includes('catalog/discs/litye/') && BANNER_ALLOY_DISKS_REGION_IDS.includes(regionId)) {
    banners.push(BannerAlloyDisks);
  }

  if (urlPage.includes('catalog/tyres/zima/')) {
    banners.push(BannerTyresWinter);
  }

  if (urlPage.includes('catalog/filter/tyres/?get_action=121111483344')) {
    banners.push(BannerTyresWinterAction);
  }

  return banners;
};
